import { render } from "./OrderDetails.vue?vue&type=template&id=2e4f4eaa&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=2e4f4eaa&scoped=true&lang=less"

import exportComponent from "D:\\perject\\suyuan\\.codex-tmp\\20260929-frontend-prod\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4f4eaa"]])

export default __exports__